<template>
    <div class="my-2" :class="containerClass">
        <slot></slot>
        <div @click="click($event, value)" @keyup.enter="$emit('update:value', (value = !value))"
            :aria-labelledby="name" class="flex flex-row gap-2 cursor-pointer" tabindex="0">
            <div :class="value ? 'text-blue border-blue' : 'text-blue-dark border-blue-dark'"
                class="flex-none rounded-md flex items-center justify-center border-2 p-0.5 text-xs w-5 h-5">
                <FontAwesomeIcon v-if="value" :icon="['fa', 'check']" />
            </div>
            <span class="w-auto leading-none link mt-0.5" v-html="label" />
        </div>
        <FormError :formComponentId="formComponentId" :name="name" v-model:status="status" />
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        label: String,
        name: String,
        containerClass: String,
        formComponentId: ''
    },

    emits: ['update:value'],

    data: () => ({
        status: null
    }),

    methods: {
        click(el, value) {
            // only trigger click if its not a link
            if (el.target.nodeName != 'A') {
                this.$emit('update:value', (value = !value));
            }
        }
    }
};
</script>
